import { apiFetch } from './client'
import { cached, invalidate } from './cache'

export interface User {
  id: string
  employee_no: string
  name: string
  email?: string
  phone?: string
  face_uploaded: boolean
  card_no?: string
  pin?: string
  sync_status: string
  created_at: string
  updated_at: string
  user_type: string
  gender?: string
  department?: string
  company?: string
  begin_time?: string
  end_time?: string
  long_term?: boolean
  user_verify_mode?: string
  // Gym fields
  document_type?: string
  id_number?: string
  birth_date?: string
  blood_type?: string
  address?: string
  occupation?: string
  emergency_contact_name?: string
  emergency_contact_phone?: string
  goal?: string
  medical_notes?: string
  needs_attention?: boolean
  member_category?: 'client' | 'staff' | 'partner'
}

export interface CreateUserInput {
  employeeNo: string
  name: string
  email?: string
  phone?: string
  cardNo?: string
  pin?: string
  userType?: string
  gender?: string
  department?: string
  company?: string
  beginTime?: string
  endTime?: string
  longTerm?: boolean
  memberCategory?: 'client' | 'staff' | 'partner'
  userVerifyMode?: string
  // Gym fields
  documentType?: string
  idNumber?: string
  birthDate?: string
  bloodType?: string
  address?: string
  occupation?: string
  emergencyContactName?: string
  emergencyContactPhone?: string
  goal?: string
  medicalNotes?: string
}

export const getUsers = () =>
  cached('users', () => apiFetch<{ users: User[] }>('/users'), 300_000)

export interface RejectedPhotoUser {
  id: string
  name: string
  employee_no: string
}

export const getRejectedPhotoUsers = () =>
  apiFetch<{ users: RejectedPhotoUser[] }>('/users/rejected-photos')

export const getUser = (id: string) =>
  apiFetch<{ user: User }>(`/users/${id}`)

export const createUser = async (data: CreateUserInput) => {
  const r = await apiFetch<{ user: User }>('/users', { method: 'POST', body: JSON.stringify(data) })
  invalidate('users')
  return r
}

export const updateUser = async (id: string, data: Partial<CreateUserInput>) => {
  const r = await apiFetch<{ user: User }>(`/users/${id}`, { method: 'PATCH', body: JSON.stringify(data) })
  invalidate('users')
  return r
}

export const deleteUser = async (id: string) => {
  const r = await apiFetch<{ success: boolean }>(`/users/${id}`, { method: 'DELETE' })
  invalidate('users')
  return r
}

export interface UserFingerprint {
  id: string
  fingerprint_id: number
  fingerprint_type: 'normalFP' | 'patrolFP' | 'superFP' | 'stressFP'
  created_at: string
}

export const getUserFingerprints = (userId: string) =>
  apiFetch<{ fingerprints: UserFingerprint[] }>(`/users/${userId}/fingerprints`)

export const deleteUserFingerprint = (userId: string, fingerprintId: number) =>
  apiFetch<{ success: boolean }>(`/users/${userId}/fingerprints/${fingerprintId}`, { method: 'DELETE' })
